<!-- graph -->
<ion-row class="pt-10">
  <ion-col size="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-between">
        <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12" class="">
          <div class="fs-16 font_bold">ESS Score Wise</div>
        </ion-col>
        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <div class="d-flex graph-icon">
            <span>
              <img src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
            </span>

            <span (click)="switchGraphType('line')">
              <img *ngIf="graphType != 'line'" src="./assets/icon/lineChartIcon.svg" alt="">
              <img *ngIf="graphType == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span>
              <img src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span class="cp" (click)="downloadChartAsPDF('ESS Score Wise', 'firstOne')">
              <img src="./assets/icon/downloadIcon.svg" alt="">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="">
        <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <div class="formLabelRegularfs16  ">
                    Year<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                    (selectionChange)="onYearChange($event.value,'firstOne')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col>
                  <div class="formLabelRegularfs16">
                    Month<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event, 'firstOne')">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
      <div id="ScoreExpWise" style="width: 100%; height: 400px;"></div>

    </div>
  </ion-col>
</ion-row>

<ion-row class="pt-10">

  
  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">PMS Score Range</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="pmsScoreRange('bar')">
              <img *ngIf="isPmsScoreRangeIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isPmsScoreRangeIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="pmsScoreRangeTable()">
              <img *ngIf="!isPmsScoreRangeTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isPmsScoreRangeTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="pmsScoreRange('line')">
              <img *ngIf="isPmsScoreRangeIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isPmsScoreRangeIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="pmsScoreRange('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isPmsScoreRangeIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isPmsScoreRangeIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('PMS Score Range','first')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency1"
                    (selectionChange)="onYearChange($event.value,'first')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth1"
                      (selectionChange)="onMonthChange($event, 'first')">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isPmsScoreRangeTable}">
          <div class="dashboardGraphTable">
            <table id="table-PMS-Score-Range-data">
              <thead>
                <tr class="custom-size">
                  <th>Score Range</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isPmsScoreTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}} </td>
                  <td>{{data.seriesValueThreeData}} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isPmsScoreRangeTable}" id="pms-score-range-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>


  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Potential Score Range</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="potentialScoreRange('bar')">
              <img *ngIf="isPotentialScoreRangeIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isPotentialScoreRangeIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="potentialScoreRangeTable()">
              <img *ngIf="!isPotentialScoreRangeTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isPotentialScoreRangeTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="potentialScoreRange('line')">
              <img *ngIf="isPotentialScoreRangeIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isPotentialScoreRangeIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="potentialScoreRange('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isPotentialScoreRangeIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isPotentialScoreRangeIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('potential score range','second')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency2"
                    (selectionChange)="onYearChange($event.value,'second')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isPotentialScoreRangeTable}">
          <div class="dashboardGraphTable">
            <table id="table-Potential-Score-Range-data">
              <thead>
                <tr class="custom-size">
                  <th>Score Range</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isPotentialScoreTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isPotentialScoreRangeTable}" id="potential-score-range-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>

</ion-row>

<ion-row class="pt-10">
  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Experience in Company</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="experienceAttritionRate('bar')">
              <img *ngIf="isExperienceAttritionRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt=""
                class="cp">
              <img *ngIf="isExperienceAttritionRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="experienceAttritionRateTable()">
              <img *ngIf="!isExperienceAttritionRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isExperienceAttritionRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="experienceAttritionRate('line')">
              <img *ngIf="isExperienceAttritionRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt=""
                class="cp">
              <img *ngIf="isExperienceAttritionRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="experienceAttritionRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isExperienceAttritionRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isExperienceAttritionRateIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Experience in Company','three')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency3"
                    (selectionChange)="onYearChange($event.value,'three')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <mat-form-field class="mat-height40 w-100 mat-input-style">
                    <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth3"
                      (selectionChange)="onMonthChange($event, 'three')">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isExperienceAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-Exp-Attrition-data">
              <thead>
                <tr class="custom-size">
                  <th>Experience (Years)</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isExperienceTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}} </td>
                  <td>{{data.seriesValueThreeData}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isExperienceAttritionRateTable}" id="experience-attrition-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>

  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50 ">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">9 Box Category</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="nineBoxAttritionRate('bar')">
              <img *ngIf="isNineBoxAttritionRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isNineBoxAttritionRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="nineBoxAttritionRateTable()">
              <img *ngIf="!isNineBoxAttritionRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isNineBoxAttritionRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="nineBoxAttritionRate('line')">
              <img *ngIf="isNineBoxAttritionRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isNineBoxAttritionRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="nineBoxAttritionRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isNineBoxAttritionRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isNineBoxAttritionRateIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('nine box category','four')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency4"
                    (selectionChange)="onYearChange($event.value,'four')">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>

              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone': !isNineBoxAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-NineBox-Attrition-data">
              <thead>
                <tr class="custom-size">
                  <th>9 Box Category</th>
                  <th>Exit Count</th>
                  <th>Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isNineBoxTableGraph">
                  <td>{{ data.xAxisValueData }}</td>
                  <td>{{ data.seriesValueOneData }}</td>
                  <td>{{ data.seriesValueTwoData }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone': isNineBoxAttritionRateTable}" id="ninebox-attrition-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>

</ion-row>